module.exports = __webpack_public_path__ + "img/34.50029237.jpg";